import { IconWrapper } from '../runtime';
export default IconWrapper('pic_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#6964FA"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#5651E6"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#817CFF"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#6964FA"
    }
  }), h("path", {
    "attrs": {
      "d": "M15.1313 4.97574C15.1313 5.65269 14.5826 6.20148 13.9056 6.20148C13.2286 6.20148 12.6799 5.65269 12.6799 4.97574C12.6799 4.29878 13.2286 3.75 13.9056 3.75C14.5826 3.75 15.1313 4.29878 15.1313 4.97574Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M7.26463 7.04805L10.177 10.9835L12.2218 8.39379L16.0332 14.1193H13.7808L12.0925 11.5832L10.1288 14.0702L7.28288 10.2247L4.46934 14.1193H2.15625L7.26463 7.04805Z",
      "fill": "white"
    }
  })]);
});